import { render } from "./CalcoloForfettarioPage.vue?vue&type=template&id=13179b86&ts=true"
import script from "./CalcoloForfettarioPage.vue?vue&type=script&lang=ts"
export * from "./CalcoloForfettarioPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__